var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.04 62.042a2.636 2.636 0 0 1 0-3.728l6.443-6.443A2.636 2.636 0 1 1 35.21 55.6l-6.442 6.442a2.636 2.636 0 0 1-3.729 0z",
    fill: "#F3F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.898 57.026-4.338 5.695c-6.839-.923-13.237-4.09-18.173-9.025-4.937-4.936-8.102-11.335-9.025-18.174l3.585-3.986-3.585-4.337c.923-6.84 4.088-13.238 9.025-18.174C38.323 4.09 44.72.923 51.56 0l4.162 2.18L59.884 0c6.838.923 13.237 4.089 18.173 9.025 4.936 4.936 8.102 11.335 9.025 18.174l-3.058 4.513 3.058 3.81c-.923 6.84-4.089 13.238-9.025 18.174s-11.335 8.102-18.173 9.025l-3.986-5.695z",
    fill: "#F3F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.898 57.026 3.986 5.695c6.838-.923 13.237-4.09 18.173-9.025 4.936-4.936 8.102-11.335 9.025-18.174l-3.058-3.81 3.058-4.513c-.923-6.84-4.089-13.238-9.025-18.174S66.722.923 59.884 0l-4.162 2.18v55.077l.176-.23z",
    fill: "#D9E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.314 84.769c-3.085-3.085-3.085-8.101 0-11.186L21.31 54.585a2.636 2.636 0 0 1 3.729 0l7.457 7.458a2.636 2.636 0 0 1 0 3.728L13.5 84.77c-3.082 3.082-8.101 3.085-11.186 0z",
    fill: "#66538C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.805 48.778-22.375-7.46a2.63 2.63 0 0 1-1.666-1.666l-7.46-22.375a2.636 2.636 0 0 1 3.335-3.334l22.374 7.46a2.63 2.63 0 0 1 1.667 1.666l7.46 22.375a2.636 2.636 0 0 1-3.335 3.334z",
    fill: "#F73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.99 31.36a2.611 2.611 0 0 1-2.637 2.637h-5.168a42.37 42.37 0 0 1-.106-2.636c0-.897.053-1.794.106-2.637h5.168a2.611 2.611 0 0 1 2.637 2.637z",
    fill: "#D9E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.68 23.069a2.63 2.63 0 0 0-1.666-1.666l-8.292-2.765v25.445l14.083 4.695a2.635 2.635 0 0 0 3.335-3.334l-7.46-22.375z",
    fill: "#E64C2E"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#66538C",
    cx: 55.722,
    cy: 31.361,
    r: 2.637
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.359 31.36a2.637 2.637 0 0 0-2.637-2.636v5.273a2.637 2.637 0 0 0 2.637-2.636z",
    fill: "#443D66"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.359 2.742v5.169a2.611 2.611 0 0 1-2.637 2.636 2.611 2.611 0 0 1-2.637-2.636V2.742c.844-.052 1.74-.105 2.637-.105.896 0 1.793.053 2.637.105zM58.359 60.648v5.168c-.844.053-1.74.106-2.637.106s-1.793-.053-2.637-.106v-5.168a2.611 2.611 0 0 1 2.637-2.637 2.611 2.611 0 0 1 2.637 2.637z",
    fill: "#D9E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.722 68.558c-18.902 0-34.28-15.377-34.28-34.279C21.443 15.378 36.82 0 55.723 0c18.901 0 34.28 15.378 34.28 34.28 0 18.9-15.379 34.278-34.28 34.278zm0-63.284c-15.994 0-29.006 13.012-29.006 29.005 0 15.994 13.012 29.006 29.006 29.006 15.993 0 29.005-13.012 29.005-29.006 0-15.993-13.012-29.005-29.005-29.005z",
    fill: "#D9E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.722 0v10.547a2.611 2.611 0 0 0 2.637-2.636V5.395c13.893 1.258 24.99 12.354 26.247 26.247H82.09a2.611 2.611 0 0 0-2.636 2.637 2.611 2.611 0 0 0 2.636 2.637h2.516C83.348 50.81 72.252 61.906 58.36 63.164v-2.516a2.611 2.611 0 0 0-2.637-2.637v10.547c18.901 0 34.28-15.377 34.28-34.279C90.001 15.378 74.622 0 55.721 0z",
    fill: "#ACBEE6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.abb0b724fd87ade3815740f4b243a4d9.svg";
export { ForwardRef as ReactComponent };